
import { useQuery } from '@tanstack/react-query';
import { BACKGROUND_FILTERS, BackgroundFilterData } from '../data/background-filters';

/**
 * Hook to fetch background prompts from static data
 */
export const useStaticBackgroundPrompts = () => {
  return useQuery({
    queryKey: ['static-background-prompts'],
    queryFn: async (): Promise<BackgroundFilterData[]> => {
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return BACKGROUND_FILTERS.sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
